<template>
  <!-- 
  [ type a 보더 옵션 / default : 없음 ]
  .border

  [ type a 간격 옵션 / default : 없음 ]
  .spacing--sm
  .spacing--md
  .spacing--lg
  -->

  <header
    class="header-horizontal-type-h"
    :class="headerClass"
  >
    <div class="nav-container-wrap">
      <div class="nav-container">
        <div class="logo-container">
          <logo></logo>
        </div>
      </div>
    </div>
    <div class="menu-main-container">
      <div class="w--1400px m--auto position--relative">
        <div class="menu-container">
          <menu-main
            class="horizontal"
            :menus="myMenu"
            :menuClick="menuClick"
            @selected="open"
            v-click-outside="menuOff"
          ></menu-main>
        </div>
        <div class="menu-user-container">
          <menu-user class="horizontal"></menu-user>
        </div>
      </div>
      <dropdown-independent-type-b
        :menus="myMenu"
        :menu="menu"
        :menuClick="menuClick"
      >
      </dropdown-independent-type-b>
    </div>

  </header>

</template>

<script>
import menu from '../js/menu'
import theme from '@/component/js/theme'

export default {
  mixins: [menu, theme],
  methods: {
    open (menu) {
      const { children = [] } = menu
      if (children.length > 0) {
        this.menu = menu
      } else {
        this.menu = null
      }
    }
  },
  components: {
    Logo: () => import('@/component/common/Logo'),
    MenuMain: () => import('@/component/layout/header/common/MenuMain'),
    MenuUser: () => import('@/component/layout/header/common/MenuUser'),
    DropdownIndependentTypeB: () => import('@/component/layout/header/dropdown/DropdownIndependentTypeB')
  }
}
</script>
